<ng-template #dialogBgSetup let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>settings.bgSetup</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #formBgSetup="ngForm" (ngSubmit)="SaveBgSetup()">

      <div class="mb-4">
        <p class="mb-4" translate>settings.defaultCrop</p>
        <div class="radio-wrapper">
          <label class="custom-radio" *ngFor="let option of cropOptions">
            <input class="custom-radio-input" [ngModel]='defaultCropType' name="defaultCropType" [value]="option.value"
              type="radio" required (change)='filterBackgroundOption(option.value)'>
            <span class="custom-radio-text" translate>{{option.description}}</span>
          </label>
        </div>
      </div>

      <div class="mb-4" *ngIf="bgTypeOptions.length > 0">
        <p class="mb-4" translate>settings.bgType</p>
        <div class="radio-wrapper">
          <label class="custom-radio" *ngFor="let option of bgTypeOptions">
            <input class="custom-radio-input" [ngModel]='backgroundType' name="backgroundType" [value]="option.value"
              type="radio" required (change)='filterBackgroundType(option.value)'>
            <span class="custom-radio-text" translate>{{option.description}}</span>
          </label>
        </div>
      </div>

      <div class="mb-4" *ngIf="bgTypeOptions.length > 0">
        <p class="mb-4" translate>settings.defaultBg</p>
        <div class="radio-wrapper">
          <ng-container *ngFor="let background of backgroundList">
            <ng-container *ngFor="let bg of backgroundListFiles">
              <label class="custom-radio" *ngIf="(bg.backgroundId === background.id)">
                <input class="custom-radio-input" [ngModel]='defaultBackground' name="defaultBackground"
                  [value]="background.id" type="radio" required (change)='selectedBg(background)'>
                <img class="custom-radio-image" [src]="bg.fileInfo.path" [alt]="background?.name" [ngbTooltip]="background.name" />
              </label>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <button type="button" class="custom-button save-button px-5 mr-3" (click)="d('Cross click')"
          translate>global.cancel</button>
        <button type="submit" class="custom-button save-button px-5" translate>global.save</button>
      </div>

    </form>

  </div>
</ng-template>